import { Article } from '../types/blog';

export const articles: Article[] = [
  {
    id: 'student-status-verification',
    title: "New Student Status Verification System",
    excerpt: "A detailed guide on how to verify your student status and access our services.",
    content: `# New Student Status Verification System

We have implemented a new verification system for students wishing to benefit from our services. This article outlines the steps to ensure compliance with our terms of use.

## Step 1 — Document Compliance

Before submitting your documents, make sure to:

> Ensure that the current academic year is clearly mentioned on your student certificate.
> Verify that the name and surname on your customer account match exactly those on your student certificate.
> If you are under 15 years old, attach parental authorization along with your student certificate.

Following these recommendations maximizes your chances of approval and saves you time.

## Step 2 — Submitting Documents

Once logged into your account:

> 1. Click on your name and surname at the top right of the screen.
![Description of the image](https://my.europeanstudent.org/images/kb/3_ES_TUTO_VERIF_1.png)
> 2. Select 'My Information' to access your account details.
> 3. Locate the orange warning message and click the indicated link. The document verification system will then open in a new window.

You will only need to submit your documents, confirm the submission, and wait for us to process them.

## Status Verification

To check if your verification has been completed, return to the same page. It will automatically update once verification is complete.

Need help? Our support team is available, and the community is also active on Discord: [https://discord.gg/europeanstudent](https://discord.gg/europeanstudent).`,
    image: "https://images.unsplash.com/photo-1498050108023-c5249f4df085?auto=format&fit=crop&q=80",
    date: "December 18, 2024",
    readTime: "4 min",
    category: "Guide",
    author: {
      name: "#TeamEuropeanStudent",
      avatar: "https://i.imgur.com/dUtV8AP.png"
    }
  },
  {
    id: 'updates-2024',
    title: "European Student's Updates for 2024",
    excerpt: "Discover all the new features and services available for students this year.",
    content: `# European Student's Updates for 2024

This year marks a major turning point for EUROPEAN STUDENT with the introduction of numerous improvements and new services to better meet your needs.

## New Student Offers

We are pleased to introduce new exclusive offers:

- **Canva Pro**: Free premium access for all verified students
- **Adobe Suite**: Special discounts on the entire Creative Cloud
- **Microsoft 365**: Full license included with your account

## Service Enhancements

We have also improved our existing services:

> 1. Redesigned user interface for more simplicity
> 2. Optimized verification system
> 3. 24/7 available technical support

![New Interface](https://images.unsplash.com/photo-1531403009284-440f080d1e12?auto=format&fit=crop&q=80)

## Upcoming Developments

Here's a glimpse of what's coming in the next few months:

- Dedicated mobile application
- Referral program
- New exclusive partnerships

Stay tuned so you don’t miss any updates!

[Discover all offers](https://my.europeanstudent.org/store)`,
    image: "https://images.unsplash.com/photo-1531403009284-440f080d1e12?auto=format&fit=crop&q=80",
    date: "December 18, 2024",
    readTime: "3 min",
    category: "News",
    author: {
      name: "#TeamEuropeanStudent",
      avatar: "https://i.imgur.com/dUtV8AP.png"
    }
  }
];

export const getArticleById = (id: string): Article | undefined => {
  return articles.find(article => article.id === id);
};

export const getArticleNavigation = (currentId: string): { prev: Article | null; next: Article | null } => {
  const currentIndex = articles.findIndex(article => article.id === currentId);
  
  return {
    prev: currentIndex > 0 ? articles[currentIndex - 1] : null,
    next: currentIndex < articles.length - 1 ? articles[currentIndex + 1] : null
  };
};
